module.exports = __webpack_public_path__ + "img/avatar7.205873b9.png";